import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SendMailsComponent } from 'src/app/components/shared/dialogs/send-mails/send-mails.component';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { SweetalertService } from 'src/app/services/sweetalert/sweetalert.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { NewReceiptCommandeComponent } from 'src/app/components/shared/dialogs/new-receipt-commande/new-receipt-commande.component';
import { ValidReceiptCommandesComponent } from 'src/app/components/shared/dialogs/valid-receipt-commandes/valid-receipt-commandes.component';

@Component({
  selector: 'app-status-commandes',
  templateUrl: './status-commandes.component.html',
  styleUrls: ['./status-commandes.component.css'],
})
export class StatusCommandesComponent implements OnInit {
  isLoading: any = true;

  statusCmds: Array<string> = [];
  isPaied: boolean = null;
  listCmds: any = [];

  currentPage: number = 0;
  totalPages: number = 1;
  pages: Array<number> = [];
  pagesDisplaied: Array<number> = [];

  statusCmd: any = [];
  cmdsListToAffect: any = [];

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private sweetalert: SweetalertService,
    private cmdsService: CommandesService,
    private clientService: ClientsService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.cmdsService.getLabeledStatus().then((lst) => {
      this.statusCmd = lst;
    });

    this.route.queryParams.subscribe((params) => {
      this.statusCmds = params.status;
      this.isPaied = params.paied;
      // console.log("params.status")
      // console.log(params.status)
      // console.log("params.paied")
      // console.log(params.paied)
      this.listCmdsClient(this.statusCmds, this.isPaied);
    });
  }

  goToNewTab(idCmd, route) {
    this.cmdsService.goToNewTab(idCmd, route);
  }

  includes(array) {
    for (var i = 0; i < array.length; i++) {
      if (this.statusCmds.includes(array[i])) {
        return true;
      }
    }
    return false;
  }

  hasValidStatus(): boolean {
    return Array.isArray(this.statusCmds) && this.statusCmds.length > 1;
  }

  async listCmdsClient(status, isPaied) {
    await this.cmdsService
      .allCmdsClientByStatus(this.currentPage, null, [status], isPaied, null)
      .then((res: any) => {
        // console.log('res listCmdsClient');
        // console.log(res);
        if (res) {
          this.isLoading = false;
          this.listCmds = res.items;
          this.totalPages = res.totalPages;
          this.currentPage = res.currentPage;
          this.pages = Array.from(Array(res.totalPages)).map((x, i) => i);
          this.splicePages();
        }
      });
  }

  splicePages() {
    // console.log("currentPage : ")
    //     console.log(this.currentPage)
    if (this.pages.length > 10) {
      // if(this.currentPage < this.pages.length-10) {
      //   this.pagesDisplaied = this.pages.splice(this.currentPage, 10);
      //   console.log("if 1 pagesDisplaied : ")
      //   console.log(this.pagesDisplaied)
      // } else
      if (this.currentPage < 5) {
        this.pagesDisplaied = this.pages.splice(0, 10);
        // console.log("if 1 pagesDisplaied : ")
        // console.log(this.pagesDisplaied)
      } else if (
        this.currentPage >= 5 &&
        this.currentPage < this.pages.length - 5
      ) {
        this.pagesDisplaied = this.pages.splice(this.currentPage - 4, 10);
        // console.log("if 2 pagesDisplaied : ")
        // console.log(this.pagesDisplaied)
      } else {
        this.pagesDisplaied = this.pages.splice(this.pages.length - 10, 10);
        // console.log("else pagesDisplaied : ")
        // console.log(this.pagesDisplaied)
      }
    } else {
      this.pagesDisplaied = this.pages;
    }
  }

  nextPage() {
    this.currentPage++;
    this.listCmdsClient(this.statusCmds, this.isPaied);
  }

  previousPage() {
    this.currentPage--;
    this.listCmdsClient(this.statusCmds, this.isPaied);
  }

  selectPage(page) {
    this.currentPage = page;
    this.listCmdsClient(this.statusCmds, this.isPaied);
  }

  validateCmds() {
    // console.log(this.cmdsListToAffect.map(item => item?._id))
    this.cmdsService
      .validateCmds({
        cmds: this.cmdsListToAffect.map((item) => item?._id),
      })
      .then(async (res: any) => {
        //  console.log("resssssssss validateCmds : ")
        //  console.log(res)
        if (res && res.response) {
          if (res?.data && res?.data?.length > 0) {
            for (var i = 0; i < res?.data?.length; i++) {
              await this.sweetalert.alertProblem(res?.data[i]?.msg);
            }
          } else {
            this.sweetalert
              .alertSuccess(this.translate.instant('data.validate_alert_cmd'))
              .then((result: any) => {
                if (result.isConfirmed) {
                  this.listCmdsClient(this.statusCmds, this.isPaied);
                }
              });
          }
        } else {
          alert(res.msg);
        }
      });
  }

  addAndRemoveCmdToAffect(event: Event, cmd: any) {
    const checked = (event.target as HTMLInputElement).checked;
    const id = cmd?._id;
    if (!id) return;

    if (checked) {
      if (!this.cmdsListToAffect.some((c) => c._id === id)) {
        this.cmdsListToAffect = [...this.cmdsListToAffect, cmd];
      }
    } else {
      this.cmdsListToAffect = this.cmdsListToAffect.filter((c) => c._id !== id);
    }
  }

  addALLCmdToAffect(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      const valids = (this.listCmds ?? []).filter(
        (c): c is any => !!c && !!c._id
      );
      const merged = [...this.cmdsListToAffect, ...valids];
      this.cmdsListToAffect = Array.from(
        new Map(merged.map((c) => [c._id, c])).values()
      );
    } else {
      this.cmdsListToAffect = [];
    }
  }

  itemIsAffected(idCmd: string | undefined | null): boolean {
    if (!idCmd) return false;
    return this.cmdsListToAffect.some((c) => c._id === idCmd);
  }

  sendMail(cmd: any) {
    const modalRef = this.modalService.open(SendMailsComponent, { size: 'lg' });
    modalRef.componentInstance.providerContacts =
      this.initProviderContacts(cmd);
    modalRef.componentInstance.transContacts = this.initTransContacts(cmd);
    modalRef.componentInstance.cmds = [cmd?._id];
    modalRef.componentInstance.cmd = cmd;

    modalRef.componentInstance.result.subscribe((receivedEntry) => {
      // console.log(receivedEntry)
      if (receivedEntry) {
        // console.log("Result from modal:", receivedEntry);
      }
    });
  }
  initProviderContacts(cmd: any) {
    let providerContacts: any[] = [];
    providerContacts.push({
      email: cmd?.client_cmd?.contactUsername,
      isChecked: false,
    });
    cmd?.client_cmd?.contacts?.forEach((contact) => {
      providerContacts.push({ email: contact?.email, isChecked: false });
    });

    return providerContacts;
  }
  initTransContacts(cmd: any) {
    let transContacts: any[] = [];
    transContacts.push({
      email: cmd?.client_cmd?.pickUpCollector?.transporter_id?.email,
      isChecked: false,
    });
    cmd?.client_cmd?.pickUpCollector?.transporter_id?.contacts?.forEach(
      (contact) => {
        transContacts.push({ email: contact?.email, isChecked: false });
      }
    );

    return transContacts;
  }

  deleteCmd(idCmd: any) {
    this.sweetalert
      .confirmActionBtn(this.translate.instant('data.deleted_pickup_alert'))
      .then((result: any) => {
        if (result.isConfirmed) {
          this.cmdsService.deleteCmd(idCmd).then((res: any) => {
            if (res) {
              if (res?.response) {
                this.sweetalert
                  .alertSuccess(
                    this.translate.instant('data.pickup_was_deleted')
                  )
                  .then(async (result: any) => {
                    if (result.isConfirmed) {
                      this.listCmdsClient(this.statusCmds, this.isPaied);
                    }
                  });
              } else {
                alert(res?.msg);
              }
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.sweetalert.alertCanceled().then((res: any) => {});
        }
      });
  }

  validateTakeOff(cmd) {
    if (cmd?.etat_cmd == 'validated')
      this.sweetalert
        .confirmActionBtn(
          this.translate.instant('data.send_confirmation_pickup_alert')
        )
        // + this.cmd?.pickupedBy?.nameSociety + " !")
        .then((result: any) => {
          if (result.isConfirmed) {
            this.cmdsService
              .sendConfirmationPickup(cmd?._id)
              .then((res: any) => {
                if (res) {
                  // console.log("successssssssss")

                  this.sweetalert
                    .alertSuccess(
                      this.translate.instant(
                        'data.sended_email_pickup_removed_alert'
                      )
                    )
                    .then(async (result: any) => {
                      if (result.isConfirmed) {
                        this.listCmdsClient(this.statusCmds, this.isPaied);
                      }
                    });
                }
              });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            this.sweetalert.alertCanceled().then((res: any) => {
              // location.href = "/product/product-list"
            });
          }
        });
  }

  validateAtDepot(cmd) {
    if (cmd?.etat_cmd == 'take_off')
      this.sweetalert
        .confirmActionBtn(this.translate.instant('data.pickup_depot-alert'))
        // + this.cmd?.pickupedBy?.nameSociety + " !")
        .then((result: any) => {
          if (result.isConfirmed) {
            this.cmdsService
              .updateCmdStatus(cmd?._id, 'transporting_depot')
              .then((res: any) => {
                if (res) {
                  // console.log("successssssssss")

                  this.sweetalert
                    .alertSuccess(
                      this.translate.instant('data.pickup_at_depot')
                    )
                    .then(async (result: any) => {
                      if (result.isConfirmed) {
                        this.listCmdsClient(this.statusCmds, this.isPaied);
                      }
                    });
                }
              });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            this.sweetalert.alertCanceled().then((res: any) => {
              // location.href = "/product/product-list"
            });
          }
        });
  }

  returnTovalidate(cmd) {
    if (cmd?.etat_cmd == 'take_off')
      this.sweetalert
        .confirmActionBtn(this.translate.instant('data.validate_alert_cmd'))
        .then((result: any) => {
          if (result.isConfirmed) {
            this.cmdsService
              .updateCmdStatus(cmd?._id, 'validated')
              .then((res: any) => {
                if (res) {
                  // console.log('successssssssss');
                  this.sweetalert
                    .alertSuccess(
                      this.translate.instant('data.validate_alert_cmd')
                    )
                    .then(async (result: any) => {
                      if (result.isConfirmed) {
                        this.listCmdsClient(this.statusCmds, this.isPaied);
                      }
                    });
                }
              });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            this.sweetalert.alertCanceled().then((res: any) => {
              // location.href = "/product/product-list"
            });
          }
        });
  }

  ReceiptCmds() {
    const modalRef = this.modalService.open(NewReceiptCommandeComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.result.subscribe((receivedEntry: any) => {
      if (receivedEntry) {
        this.listCmdsClient(this.statusCmds, this.isPaied);
      }
    });
  }

  ValidReceiptCmds() {
    const modalRef = this.modalService.open(ValidReceiptCommandesComponent, {
      size: 'xl',
    });
    modalRef.componentInstance.selectedCmds = this.cmdsListToAffect;
    modalRef.componentInstance.result.subscribe((receivedEntry: any) => {
      if (receivedEntry) {
        this.cmdsListToAffect = [];
        this.listCmdsClient(this.statusCmds, this.isPaied);
      }
    });
  }
}
